import React from "react"
import ReactDOM from "react-dom"
import TimaticWidget from "./timatic-widget-component"

export default class TimaticWidgetModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<TimaticWidget />, self.elem)
  }
}
